var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-primary mb-6"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero-body"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subTitle)?_c('p',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }